// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"515":"012f0f88","545":"22e42313","672":"208ac3e5","989":"f9f923ec"}[chunkId] + ".js";
};